module.exports = __webpack_public_path__ + "img/index5.3e66af47.webp";